import type { AnalyticsPluginOptions } from '@atlaskit/editor-plugin-analytics/analyticsPluginType';

interface Props {
	options: never;
}

export function analyticsPluginOptions({}: Props): AnalyticsPluginOptions {
	return {};
}
